
export const name = "pricing-pages-ui-public-app";
export const version = "dev";
